import * as React from "react";
import CancelSubscriptionProcedurePage from "../pages/CancelSubscriptionProcedure";

const CancelSubscriptionProcedure = (): JSX.Element => {
    return <CancelSubscriptionProcedurePage />;
};

export default CancelSubscriptionProcedure;
